import { createSlice } from '@reduxjs/toolkit';
import { type GeoTripData } from 'types/geo.types';

export interface InclinometerState {
  events: any[];
  isLoading: boolean;
  tirePressure: any;
  fuelEfficiency: any;
  gpsData: GeoTripData[];
  inclineAngles: any[];
  defaultAngles: any[];
  pitsCoords: {
    loadingUnloadingAreas: any[];
  };
  assetTires: any[];
}

const initialState: InclinometerState = {
  events: [
    { incorrect_gear: [] },
    { overspeed: [] },
    { braking: [] },
    { acceleration: [] },
    { incorrect_gear_shift: [] },
    { gear_skip: [] },
  ],
  isLoading: false,
  tirePressure: {},
  fuelEfficiency: {
    device: [],
    fleet: [],
  },
  gpsData: [],
  inclineAngles: [],
  defaultAngles: [],
  pitsCoords: {
    loadingUnloadingAreas: [],
  },
  assetTires: [],
};

export const idleAnalyticsSlice = createSlice({
  name: 'inclinometer',
  initialState,
  reducers: {
    setInclinometerEvent(state, { payload }) {
      state.events = payload;
    },
    setTirePressure(state, { payload }) {
      state.tirePressure = payload;
    },
    setFuelEfficiency(state, { payload }) {
      state.fuelEfficiency = payload;
    },
    setInclineAngles(state, { payload }) {
      state.inclineAngles = payload;
    },
    setGpsData(state, { payload }) {
      state.gpsData = payload;
    },
    setDefaultAngles(state, { payload }) {
      state.defaultAngles = payload;
    },
    setLoadingState(state, { payload }) {
      state.isLoading = payload;
    },
    setPitsCoords(state, { payload }) {
      state.pitsCoords = payload;
    },
    setAssetTires(state, { payload }) {
      state.assetTires = payload;
    },
  },
});

export const {
  setInclinometerEvent,
  setTirePressure,
  setFuelEfficiency,
  setGpsData,
  setInclineAngles,
  setDefaultAngles,
  setLoadingState,
  setPitsCoords,
  setAssetTires,
} = idleAnalyticsSlice.actions;
export default idleAnalyticsSlice.reducer;
